/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerRoleRegistrationRequestModel } from '../../models/practitioner-role-registration-request-model';

export interface PractitionerRegisterWithRolesPost$Params {
      body?: PractitionerRoleRegistrationRequestModel
}

export function practitionerRegisterWithRolesPost(http: HttpClient, rootUrl: string, params?: PractitionerRegisterWithRolesPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, practitionerRegisterWithRolesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PracticeStrictHttpResponse<void>;
    })
  );
}

practitionerRegisterWithRolesPost.PATH = '/Practitioner/RegisterWithRoles';
